import { execute } from "./common";
import { DashAction } from "@/features/dashboard";
import every from "lodash/every";

export default function*() {
  yield execute(
    [
      DashAction.fetchDashboardMeta.request(),
      DashAction.fetchBenchmarkAnalysis.request("SGX"),
      DashAction.fetchSectorIndustryPerf.request()
    ],
    state => every(state.dashboard.status, v => v === "SUCCESS")
  );
}
